"use client";

import dynamic from "next/dynamic";

/*
 * Dev-only annotation overlay. Loaded through a dynamic import so the
 * "agentation" package never ends up in the production JavaScript bundle
 * (a plain import was shipping ~100 KB of it to every visitor).
 */
const Agentation = dynamic(
	() => import("agentation").then((mod) => mod.Agentation),
	{ ssr: false },
);

export default function DevAgentation() {
	return <Agentation />;
}
